// extracted by mini-css-extract-plugin
module.exports = {"icon":"AddAffiliate_icon__XzGVw"};